module.exports = __webpack_public_path__ + "img/album07_28.bfad2517.jpg";